module.exports = __webpack_public_path__ + "35518a6b9b0f5741e1e39f8d34db4386.svg";